import { render, staticRenderFns } from "./ChatBotDrawerMcp.vue?vue&type=template&id=5e842712&"
import script from "./ChatBotDrawerMcp.vue?vue&type=script&lang=ts&"
export * from "./ChatBotDrawerMcp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports